import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { sweetAlert } from "../../../utils/swal";
import {
  downloadFile,
  downloadFileAsBlob,
  getArrayBuffer,
} from "src/app/utils/pdf-downloader";
import * as moment from "moment-timezone";
import { ActivatedRoute, Router } from "@angular/router";
import { urls } from "src/app/utils/url-utils";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import * as _ from "underscore";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { DispatchCenterService } from "../../dashboard/dashboard-service/dispatch-center-service";
import { FleetService } from "../../fleet/fleet-service/fleet.service";
import {
  PAYOR,
  checkRole,
  exportToCsv,
  getBillingBrokers,
  getBrokersList,
  urlToBase64,
} from "src/app/utils/utils.common";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { generatePdf, getCompanyLogo, calculateClaimAmount } from "src/app/utils/utils.common";
import { Cms1500Service } from "src/app/service/cms-service/cms1500.service";
import { PDFDocument } from "pdf-lib";
import { isArray } from "util";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FilterPipe } from "src/app/pipe/list-filter-pipe/list-filter-pipe";
import { FilterByKeyPipe } from "src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe";
import { ModivcareReportService } from "src/app/service/modivcare-report-service/modivcare-report.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { UserRoles } from "../../shared/layout/menu-service/menu.service";
import { CsvService } from "src/app/service/csv-service/csv.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
@Component({
  selector: "app-verified-trip-logs",
  templateUrl: "./verified-trip-logs.component.html",
  styleUrls: ["./verified-trip-logs.component.css"],
})
export class VerifiedTripLogsComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  // tslint:disable-next-line: ban-types
  public signaturePadOptions: Object = {
    // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 750,
    canvasHeight: 300,
  };


  status;
  user;
  timeZone;
  searchDate;
  dateRange;
  search = "";
  dataList = [];
  filteredAdjustedTrips = [];
  selectedTrips = [];
  selectedTripJobIds = [];
  brokers;
  // selectedBroker = "";

  drivers = [];
  members = [];
  selectedDriver = "";
  selectedMember = "";
  selectedSpacetype = "";
  selectedServiceArea = "";
  selectedLos = "";
  corporateUsers;
  selectedCorporateUser;
  isMedical = false;
  claimModalObj:any

  projectedOdometer = "";
  tempVin;
  odometerBegin;
  odometerStart;
  odometerStop;

  isOdometerRequest = false;
  isAllTripsSelected = false;

  popupAssignTrip: any;
  bankedType;

  jobType = "assigned";
  type = null;
  tempCompanyImage =
    "https://s3.amazonaws.com/neighborhood-dev/assets/brokers/MixandMatch.png";
  companyImage = this.tempCompanyImage;
  fleet;
  isShowFilter = false;
  odomterModalObj;
  signatureModalObj;

  preCorporate;
  preFleet;
  preLevelOfServices = {};
  preSpaceTypes = {};

  driverLoader = {
    isLoading: false,
  };

  modivcareTripLog = {
    isLoading: false
  }
  isTripLogLoader = {
    isLoading: false
  }

  trfLoader = {
    isLoading: false
  }

  selectedCorporateId = '';
  view = "grid";
  alertMessage = "";
  orderBy = "scheduleTime";
  selectedDropdownIndex
  toggleActionButtons = false;
  isAllowRates: boolean = false;
  preServiceAreas: any = {};
  spaceTypeList: any = [];
  serviceAreaList: any = [];
  levelOfServiceList: any = [];
  filteredSpaceTypeList = [];
  filteredServiceAreaList = [];
  filteredLosList = []



  constructor(
    private csvService: CsvService,
    private levelOfServiceService: LevelOfServiceService,
    private modivcareService: ModivcareReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private fleetService: FleetService,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService,
    private router: Router,
    private serviceArea : ServiceAreasService
  ) { }

  ngOnInit() {
    this.status = "adjustedtriplogs";
    this.brokers = getBillingBrokers;
    this.getUser();
    this.getCorporateUsers();
    this.getFleetList();
    this.getSpaceTypes();
    this.getLevelOfService();
    this.getServiceAreas();
  }

  ngAfterViewInit() {
    if (this.signaturePad) {
      // this.signaturePad is now available
      this.signaturePad.set("minWidth", 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.timeZone = user.timeZone;
          this.user = user;
          // this.searchDate = moment().startOf('day').toISOString();
          this.searchDate = moment
            .tz(this.timeZone)
            .startOf("day")
            .toISOString();
          this.dateRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getAdjustedTrips();
          this.isAllowRates = checkRole(this.user);
        }


      });
  }

  getCorporateUsers() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data;
          this.preCorporate = data.reduce(
            (obj, item) => ((obj[item._id] = item), obj),
            {}
          );

        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getCorporateByID(id) {
    return this.preCorporate[id];
  }

  getAdjustedTrips() {
    let queryParams = {
      status: this.status,
      scheduleTime: this.searchDate,
      jobType: this.jobType,
    };

    if (this.isMedical) {
      queryParams["isMedical"] = this.isMedical;
    }

    if (this.selectedCorporateId) {
      queryParams["cooperate"] = this.selectedCorporateId;
    }


    this.members = [];
    this.drivers = [];
    this.selectedTrips = [];
    this.filteredAdjustedTrips = [];
    this.dataList = [];
    this.filteredSpaceTypeList = [];
    this.filteredServiceAreaList = [];
    this.filteredLosList = []
    let losIds = [];
    let spaceTypeIds = [];
    let serviceAreaIds = [];


    this.search = "";
    this.selectedMember = "";
    this.selectedDriver = "";
    this.selectedSpacetype = "";
    this.selectedServiceArea = "";
    this.selectedLos = "";

    this.assignTripService
      .getAdjustedTripsList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList = data;
          this.filteredAdjustedTrips = data;

          this.dataList.forEach((trip, i) => {
            trip.los = trip.spaceType && (this.preSpaceTypes && this.preSpaceTypes[trip.spaceType])
              ? this.preSpaceTypes[trip.spaceType].los
              : '';
            const isFound = this.drivers.some(
              (driver) => driver._id === trip.driver._id
            );
            if (!isFound) {
              this.drivers.push(trip.driver);
            }
            this.members.push(trip.priorityClient);

            if (trip.spaceType) {
              spaceTypeIds.push(trip.spaceType);
            }

            if (trip.serviceArea) {
              serviceAreaIds.push(trip.serviceArea);
            }

            if (trip.los) {
              losIds.push(trip.los);
            }

          });

          spaceTypeIds = _.uniq(spaceTypeIds);
          serviceAreaIds = _.uniq(serviceAreaIds);
          losIds = _.uniq(losIds);

          this.filteredSpaceTypeList = this.spaceTypeList.filter(st =>
            spaceTypeIds.includes(st._id)
          );

          this.filteredLosList = this.levelOfServiceList.filter(los =>
            losIds.includes(los._id)
          );

          this.filteredServiceAreaList = this.serviceAreaList.filter(s => serviceAreaIds.includes(s._id))

          this.members = _.uniq(this.members, (obj) => obj.displayName);

          this.filterTripsByModel();
        }
      });
  }

  onSearchDateChange(event) {
    this.searchDate = event.toISOString();
    this.getAdjustedTrips();
  }

  onDateRangeChange(event) {
    if (event && event.length) {
      this.dateRange = [
        event[0].toISOString(),
        event[1].endOf("day").toISOString(),
      ];
    }

    this.getAdjustedTrips();
  }

  onSelectCorporateUser() {

    if (this.selectedCorporateId) {
      this.selectedCorporateUser = this.preCorporate[this.selectedCorporateId];
      this.jobType = "cooperate";
      this.isMedical = false;

      this.getAdjustedTrips();
    } else {
      this.selectedCorporateId = "";
      this.selectedCorporateUser = null;
      this.jobType = "assigned";
      this.companyImage = this.tempCompanyImage;
      this.getAdjustedTrips();
    }

  }

  onSelectDriver() {
    this.filterTripsByModel();
    if (this.filteredAdjustedTrips.length) {
      const trip = this.filteredAdjustedTrips[0];
      if (trip && trip.fleet) {
        const fleetId = trip.fleet;
        this.projectedOdometer = null;
        this.fleetService
          .getFleetDataById(fleetId)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              this.fleet = data;
              // this.projectedOdometer = this.fleet[this.selectedBroker];
            }
          });
      }
    }
  }

  // Trip Selection Starts
  selectTrips(assign) {
    const index = this.selectedTrips.indexOf(assign._id);
    if (index > -1) {
      assign.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      assign.isSelected = true;
      this.selectedTrips.push(assign._id);
    }
  }

  selectAll() {

    this.filteredAdjustedTrips.forEach((assign) => {
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filteredAdjustedTrips.length;
    return this.isAllTripsSelected;
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filteredAdjustedTrips.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });
    this.selectedTrips = this.selectedTrips.filter(
      (x) => !unselectedTrips.includes(x)
    );
    this.isAllTripsSelected = false;
  }

  filterTripsByModel() {
    this.filteredAdjustedTrips = this.dataList;

    this.filteredAdjustedTrips = new FilterPipe().transform(
      this.filteredAdjustedTrips,
      this.search
    );

    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.priorityClient.displayName",
      this.selectedMember
    );


    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.driver._id",
      this.selectedDriver
    );
    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.spaceType",
      this.selectedSpacetype
    );
    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.serviceArea",
      this.selectedServiceArea
    );
    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.los",
      this.selectedLos
    );
  }

  getSelectedTrips() {
    return this.dataList.filter((trip) => trip.isSelected);
  }

  adjustOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };
    this.assignTripService
      .adjustTripOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
        }
      });
  }

  // OK
  nextOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };

    this.assignTripService
      .adjustAllTripsOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
        }
      });
  }

  signatureUpdate(isSignature) {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      isSignature: isSignature,
    };

    this.assignTripService
      .signatureUpdate(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Updated Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // OK
  bankedTrips() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: "banked",
    };

    this.assignTripService
      .bankedTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Banked the Trip Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // Adjust Odometer
  showOdometerModal(trip) {
    this.odomterModalObj = trip;
  }

  showClaimModal(trip:any) {
    this.claimModalObj = trip;
  }

  onSaveOdometer(evt) {
    this.dataList.forEach((item, i) => {
      if (item._id === evt._id) {
        this.dataList[i].odometerBegin = evt.odometerBegin;
        this.dataList[i].odometerStart = evt.odometerStart;
        this.dataList[i].odometerStop = evt.odometerStop;
      }
    });
    this.odomterModalObj = null;
  }

  // Signature
  showSignatureModal(trip) {
    this.signatureModalObj = trip;
  }

  onSaveSignature(data) {
    if (data) {
      this.signatureModalObj.signatureImage = data + "?" + Math.random();
      // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
      const payload = {
        isEmpty: false,
        dataUrl: data,
      };
      this.assignTripService
        .generateSignature(payload, this.signatureModalObj._id)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            this.signatureModalObj.signatureImage = data.signatureImage;
            this.signatureModalObj = null;
          }
        });
    }
  }

  getBroker(key) {
    return getBrokersList[key];
  }

  // Banked
  bankedSingleTrip(assign, status) {
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
    this.bankedType = status;
    // tslint:disable-next-line: max-line-length
    this.alertMessage =
      assign.bankStatus === "banked"
        ? "Are you sure you want to appeald against this trip ?"
        : "Are you sure you want to bank this trip ?";
    const object = {
      type: "adjustedtriplogs",
      _ids: [this.popupAssignTrip._id],
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: this.bankedType,
      statusType: "single",
    };
    this.assignTripService
      .bankedTrips(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `Trip ${this.bankedType === 'banked' ? 'Banked': 'Appealed'} Successfully`, 'success', 'OK');
          this.selectedTrips = [];
          this.selectedTripJobIds = [];
          this.getCorporateUsers();
          this.getAdjustedTrips();
        }
      });
  }

  bankedMultipalTrips() {
    this.alertMessage = "Are you sure you want to bank these trips ?";
  }
  // Signature

  updateTripSignature(assign) {
    this.signaturePad.clear();
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
  }

  generateSignature() {
    const object = {
      isEmpty: false,
      dataUrl: this.signaturePad.toDataURL(),
    };
    this.processSignature(object, this.popupAssignTrip._id);
  }

  processSignature(obj, id) {
    this.assignTripService
      .generateSignature(obj, id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
          const splitArray = data.signatureImage.split("/");
          const splitArrayTwo = splitArray[6].split(".");
          this.dataList.filter((item2) => {
            if (item2._id === splitArrayTwo[0]) {
              item2.signatureImage = data.signatureImage;
            }
          });
        }
      });
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  btnNagtiveResponse() {
    this.popupAssignTrip = JSON.parse(JSON.stringify({}));
    this.alertMessage = "";
  }
  // Methods will stay

  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }

  navigateToAdjustment(id) {
    const queryParams = { isFromBilling: true };
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/trips/${id}/adjust`], { queryParams })
    );
    window.open(url, "_blank");
    // this.router.navigate([`/trips/${id}/adjust`], { queryParams } );
  }

  async modivcareReport() {
    this.modivcareTripLog.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getModivcareReport(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.modivcareTripLog);
    }
  }

  async downloadTripLog() {
    this.isTripLogLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getTripLog(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.isTripLogLoader, this.selectedCorporateUser);
    }
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {


    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  downloadForm837Reportv2() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReportv2(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  downloadForm837Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReport(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  group(isNotFromButton?) {
    if (this.filteredAdjustedTrips && this.filteredAdjustedTrips.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filteredAdjustedTrips.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filteredAdjustedTrips.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  callthecarInvoice() {
    if (this.selectedTrips.length) {
      const selectedTripsObj = this.dataList.filter(trip => this.selectedTrips.includes(trip._id));
      this.csvService.downloadCTCInvoice(selectedTripsObj, this.preFleet, this.user, this.timeZone);
    } else {
      return;
    }
  }

  cms1500Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address
    };

    const payload = {
      _ids: selectedTripIds,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName,
      cooperate: cooperatePayload
    }
    this.assignTripService.getCMS1500Report(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  downloadRawTripReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    // this.csvService.generateRawTripReport(selectedTrip, this.dateRange, this.timeZone, this.preCorporate, this.preLevelOfServices, this.preSpaceTypes, this.preServiceAreas, this.preFleet)

  }

  calculateClaimTotal(trip) {
   return calculateClaimAmount(trip);
  }

 closeClaimModal(evt:any){
  if(evt){
    console.log("Event check",evt);
    const idx = this.filteredAdjustedTrips.findIndex((t) => t._id === evt._id);
    if (idx > -1) {
      this.filteredAdjustedTrips[idx] = evt;
    }
  }
   this.claimModalObj = null;

 }


  ngOnDestroy(): void { }
}
